<div class="radio-button-group" [attr.data-id]="dataId">
    <label class="group-label">{{ label }} @if (required) {
<span class="text-danger">*</span>
}</label>

    <div class="button-options">
        @for (option of options; track option) {
<app-button [label]="getOptionLabel(option)" [attr.data-id]="option"
            [color]="isSelected(option) ? 'primary' : 'secondary-radio'"
            [disabled]="isDisabled || selectedValue !== null" (clicked)="onSelect(option)">
        </app-button>
}
    </div>

    @if (control && control.invalid && (control.dirty || control.touched)) {
<div class="text-danger">
        @if (control.errors?.required) {
<div>Please select an option.</div>
}
    </div>
}
</div>